import { useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import ChipsDropdown from 'components/ChipsDropdown'
import { filterOptions } from 'consts'
import { useTranslate } from 'lib/tolgee'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'

export default function DateRangeFilter() {
  const t = useTranslate()
  const location = useLocation()
  const history = useHistory()

  const handleChange = value => {
    const newSearchParams = new URLSearchParams(location.search)
    if (value?.value) {
      newSearchParams.set('dateRange', String(value?.value))
    } else {
      newSearchParams.delete('dateRange')
    }

    const { FILTER_METRICS } = analyticsTracker.eventNames

    analyticsTracker.eventTrack(FILTER_METRICS, {
      selectedChip: value.value || 'all',
    })

    const filterSearchParams = newSearchParams.toString()
    history.push({ search: filterSearchParams })
  }

  const dateRange = useMemo(() => {
    const newSearchParams = new URLSearchParams(location.search)

    const defaultDateRange = { label: t(TOLGEE_GLOBALS.lastTwelveMonths), value: 12 }

    const dateRangeValue = newSearchParams.get('dateRange')
    const selectedDateRange = filterOptions.uploadDateSearchTopics.find(item => String(item.value) === dateRangeValue)

    return dateRangeValue ? selectedDateRange : defaultDateRange
  }, [location.search, t])

  return (
    <ChipsDropdown
      label={t(TOLGEE_GLOBALS.uploadDate)}
      onChange={handleChange}
      options={filterOptions.uploadDateSearchTopics}
      selected={dateRange}
    />
  )
}
